import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { postData } from '../Services/api';

const Reply = ({ helpId, onSuccess }) => {
    const [replyText, setReplyText] = useState('');
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!replyText.trim()) {
            toast.warning("Reply message is required");
            return;
        }
        setLoading(true)
        try {
            const res = await postData(`/support/message-reply/${helpId}`, { reply: replyText });
            if (res.status) {
                toast.success("Reply sent successfully");
                setReplyText('');
                document.getElementById('close-btn-reply')?.click();
                onSuccess(); // Refresh the list
            } else {
                toast.error(res.message || "Failed to send reply");
            }
        } catch (err) {
            console.error("Reply error", err);
            toast.error("Server error");
        } finally {
            setLoading(false)
        }
    };
    return (
        <>
            <div
                className="modal fade"
                id="customer-edit_add-modal"
                data-bs-keyboard="false"
                tabIndex={-1}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="mb-0 mx-2">Reply to Agnes McGee</h5>
                            <a
                                href="#"
                                className="avtar avtar-s btn-link-danger btn-pc-default"
                                data-bs-dismiss="modal"
                                id='close-btn-reply'
                            >
                                <i className="fas fa-x f-20" />
                            </a>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label">Reply Message</label>
                                            <textarea
                                                rows={5}
                                                className="form-control"
                                                placeholder="Write your reply here..."
                                                value={replyText}
                                                onChange={(e) => setReplyText(e.target.value)}
                                            />
                                        </div>
                                        <hr className="my-3 border border-secondary-subtle" />
                                    </div>
                                    <div className="modal-footer justify-content-between">
                                        <div className="flex-grow-1 text-end">
                                            <button
                                                type="button"
                                                className="btn btn-link-danger btn-pc-default"
                                                data-bs-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                // data-bs-dismiss="modal"
                                                disabled={loading}

                                            >
                                                {loading ? 'Replying...' : 'Reply'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Reply